module.exports = __webpack_public_path__ + "img/1440.91871959.jpg";